module.exports = __webpack_public_path__ + "f2b8327ffc5d36771a63dc24d571ba60.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/bowtie.png
// module id = 1811
// module chunks = 0